(function() {
  // =========================================================
  // STEP 1: AGENCY MAPPING — YAHA APNI 22 AGENCIES FILL KARO
  // =========================================================
  var AGENCY_MAP = {
    "8294670178": "Agency 1",
    "1234567890": "Agency 2",
    // ... baaki agencies yaha add karo
  };

  var COOKIE_FIRST = "attribution_first";
  var COOKIE_LAST  = "attribution_last";
  var COOKIE_PATH  = "attribution_path";
  var COOKIE_DAYS  = 30;
  var MAX_URL_LEN  = 1000;
  var MAX_PATH     = 5;

  function getParam(name) {
    try {
      var url = new URL(window.location.href);
      return url.searchParams.get(name);
    } catch (e) { return null; }
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function safeParse(raw) {
    try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }

  function captureAttribution() {
    var gclid        = getParam("gclid");
    var fbclid       = getParam("fbclid");
    var twclid       = getParam("twclid");
    var utmSource    = getParam("utm_source");
    var utmMedium    = getParam("utm_medium");
    var utmCampaign  = getParam("utm_campaign");
    var utmTerm      = getParam("utm_term");
    var hsaAcc       = getParam("hsa_acc");
    var hsaCam       = getParam("hsa_cam");
    var hsaGrp       = getParam("hsa_grp");
    var hsaAd        = getParam("hsa_ad");
    var hsaKw        = getParam("hsa_kw");
    var gadCampaign  = getParam("gad_campaignid");
    var campaignName = getParam("campaign_name") || utmCampaign || "";

    var isAdVisit = gclid || fbclid || twclid || utmSource || hsaAcc || gadCampaign;
    if (!isAdVisit) return;

    var agency = "Unknown";
    if (hsaAcc && AGENCY_MAP[hsaAcc]) {
      agency = AGENCY_MAP[hsaAcc];
    } else if (utmSource && AGENCY_MAP[utmSource]) {
      agency = AGENCY_MAP[utmSource];
    }

    var platform = "unknown";
    if (utmSource) platform = utmSource;
    else if (gclid || gadCampaign) platform = "google";
    else if (fbclid) platform = "facebook";
    else if (twclid) platform = "twitter";

    var data = {
      agency: agency,
      platform: platform,
      campaign_id: gadCampaign || hsaCam || utmCampaign || "",
      campaign_name: campaignName,
      ad_group_id: hsaGrp || "",
      ad_id: hsaAd || "",
      keyword: hsaKw || utmTerm || "",
      gclid: gclid || "",
      fbclid: fbclid || "",
      utm_source: utmSource || "",
      utm_medium: utmMedium || "",
      utm_campaign: utmCampaign || "",
      landing_page: window.location.pathname,
      full_url: window.location.href.substring(0, MAX_URL_LEN),
      timestamp: new Date().toISOString()
    };

    var jsonData = JSON.stringify(data);

    if (!getCookie(COOKIE_FIRST)) {
      setCookie(COOKIE_FIRST, jsonData, COOKIE_DAYS);
    }
    setCookie(COOKIE_LAST, jsonData, COOKIE_DAYS);

    var d = new Date();
    var dateStr = d.getDate() + " " + d.toLocaleString("en-US", { month: "short" });
    var step = platform + (campaignName ? " / " + campaignName : "") + " (" + dateStr + ")";
    var path = safeParse(getCookie(COOKIE_PATH)) || [];
    if (path[path.length - 1] !== step) {
      path.push(step);
      if (path.length > MAX_PATH) path = path.slice(-MAX_PATH);
      setCookie(COOKIE_PATH, JSON.stringify(path), COOKIE_DAYS);
    }
  }

  captureAttribution();

  function pushAttributionToCart() {
    var f = safeParse(getCookie(COOKIE_FIRST));
    var l = safeParse(getCookie(COOKIE_LAST));
    var p = safeParse(getCookie(COOKIE_PATH));
    if (!f && !l) return;

    var attributes = {};

    if (f) {
      attributes["First Touch Agency"]        = f.agency;
      attributes["First Touch Platform"]      = f.platform;
      attributes["First Touch Campaign"]      = f.campaign_id;
      attributes["First Touch Campaign Name"] = f.campaign_name || "";
      attributes["First Touch Gclid"]         = f.gclid;
      attributes["First Touch URL"]           = f.full_url || "";
      attributes["First Touch Timestamp"]     = f.timestamp;
    }
    if (l) {
      attributes["Last Touch Agency"]         = l.agency;
      attributes["Last Touch Platform"]       = l.platform;
      attributes["Last Touch Campaign"]       = l.campaign_id;
      attributes["Last Touch Campaign Name"]  = l.campaign_name || "";
      attributes["Last Touch Gclid"]          = l.gclid;
      attributes["Last Touch URL"]            = l.full_url || "";
      attributes["Last Touch Timestamp"]      = l.timestamp;
    }
    if (p && p.length) {
      attributes["Touch Path"]  = p.join(" > ");
      attributes["Touch Count"] = String(p.length);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).then(function(r) {
      console.info("[Attribution] cart updated:", r.status, attributes);
    }).catch(function(err) {
      console.error("[Attribution] cart update failed:", err);
    });
  }

  var pushTimer = null;
  function schedulePush(delay) {
    clearTimeout(pushTimer);
    pushTimer = setTimeout(pushAttributionToCart, delay || 300);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)/.test(String(url || ""));
  }

  var _origFetch = window.fetch.bind(window);
  window.fetch = function(input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = _origFetch(input, init);
    if (isCartMutation(url)) {
      p.then(function() { schedulePush(100); }).catch(function() {});
    }
    return p;
  };

  var _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._attrUrl = url;
    return _origOpen.apply(this, arguments);
  };
  var _origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (isCartMutation(this._attrUrl)) {
      this.addEventListener("load", function() { schedulePush(100); });
    }
    return _origSend.apply(this, arguments);
  };

  pushAttributionToCart();

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      schedulePush(800);
    }
  }, true);

  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest(
      '[name="add"], .add-to-cart, [data-add-to-cart], [data-atc], ' +
      '[name="checkout"], [href*="/checkout"], [class*="gokwik"], [id*="gokwik"], [class*="buy-now"], [class*="quick-add"]'
    );
    if (btn) schedulePush(150);
  }, true);

  window.addEventListener('pageshow', function() { schedulePush(300); });

})();